package com.parmartechnologies.ui.component.image

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import com.parmartechnologies.core.feature.mediaFile.model.MediaFile
import com.parmartechnologies.ui.core.mediaFile.viewModel.MediaFileViewModel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime

class Image {
    private val viewModal = MediaFileViewModel()
    @OptIn(ExperimentalTime::class)
    val mediaFile: MutableStateFlow<MediaFile?> = MutableStateFlow(MediaFile())

    fun load(id: String) {
        viewModal.loadMedia(id) { file ->
            viewModal.scope.launch {
                if (file?.FileURL.isNullOrEmpty()) {
//                    mediaFile.emit(MediaFile(FileURL = Server.image(id)))
                } else {
                    mediaFile.emit(file)
                }
            }
        }
    }

    fun load(id: String, alternate: String) {
        viewModal.loadMedia(id) { file ->
            if (file?.FileURL.isNullOrEmpty()) {
                viewModal.loadMedia(alternate) { alternateFile ->
                    viewModal.scope.launch {
                        if (alternateFile?.FileURL.isNullOrEmpty()) {
//                            mediaFile.emit(MediaFile(FileURL = Server.image(id)))
                        } else {
                            mediaFile.emit(file)
                        }
                    }
                }
            } else {
                viewModal.scope.launch {
                    if (file.FileURL.isEmpty()) {
//                        mediaFile.emit(MediaFile(FileURL = Server.image(id)))
                    } else {
                        mediaFile.emit(file)
                    }
                }
            }
        }
    }

    @Composable
    fun content(id: String, onFail: (() -> Unit) = {}) {
        val media = mediaFile.collectAsState()
        load(id)
            AsyncImageView(media.value?.FileURL ?: "")
    }

    @Composable
    fun content(id: String, alternate: String, onFail: (() -> Unit) = {}) {
        val media = mediaFile.collectAsState()
        load(id, alternate)
        AsyncImageView(media.value?.FileURL ?: "")
    }

}